import ModalWindowLayout from 'shared/ui/ModalWindowLayout'

interface Props {
  onClick: () => void
  isDisabled: boolean
}
const ConfirmLogout = ({ onClick, isDisabled }: Props) => {
  const handleClickLogout = () => {
    onClick()
  }

  return (
    <ModalWindowLayout
      title="Вы действительно хотите выйти с аккаунта?"
      submitClassname="!bg-red_2"
      onSubmit={handleClickLogout}
      disabledSubmit={isDisabled}
    >
      <span className="text-[15px] leading-[22px] text-dark">
        После выхода не оформленные заказы будут очищены.
      </span>
    </ModalWindowLayout>
  )
}

export default ConfirmLogout
